import { useQuery } from '@tanstack/react-query';

import { IUnit } from '@/interfaces/IUnit';

import api from '../services/api';

const getAssignedUnits = (): Promise<{ data: { data: { units: IUnit[] } } }> => api.get(`/api/frontend/units/assigned`);

export const useAssignedUnits = () =>
  useQuery({
    queryKey: ['assigned_units'],
    queryFn: () => getAssignedUnits(),
    select: data => data.data.data.units
  });
